import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import PermissionGuard from "@/permissions/PermissionGuard";
import { PERMISSIONS } from "@/permissions/constant";
import TabsBar from "@/pages/super-admin/tenant-details/components/TabsBar";
import TenantPicker from "./components/TenantPicker";
import UserActionsTab from "./tabs/UserActionsTab";
import PlatformSaTab from "./tabs/PlatformSaTab";
import LlmCallsTab from "./tabs/LlmCallsTab";
import MigrationsTab from "./tabs/MigrationsTab";

const TABS = [
  { id: "user-actions", label: "User Actions" },
  { id: "platform-sa", label: "Platform SA" },
  { id: "llm-calls", label: "LLM Calls" },
  { id: "migrations", label: "Migrations" },
];

const AuditLogsDashboard = () => {
  const setHeader = useOutletContext();
  const [tenant, setTenant] = useState(null);
  const [activeTab, setActiveTab] = useState("user-actions");

  useEffect(() => {
    setHeader({ title: "Audit Logs", subTitle: "Inspect tenant activity, platform events, LLM calls, and migrations" });
    return () => setHeader({ title: "", subTitle: "" });
  }, [setHeader]);

  return (
    <PermissionGuard permission={PERMISSIONS.SUPER_ADMIN_MANAGE}>
      <div className="flex flex-col gap-3" style={{ zoom: 0.85 }}>
        <div className="flex flex-col sm:flex-row sm:items-center gap-2.5 justify-between">
          <TenantPicker value={tenant} onChange={setTenant} />
          <TabsBar activeTab={activeTab} onTabChange={setActiveTab} tabs={TABS} />
        </div>

        {activeTab === "user-actions" && <UserActionsTab tenantId={tenant?.tenantId} />}
        {activeTab === "platform-sa" && <PlatformSaTab tenantId={tenant?.tenantId} />}
        {activeTab === "llm-calls" && <LlmCallsTab tenantId={tenant?.tenantId} />}
        {activeTab === "migrations" && <MigrationsTab tenantId={tenant?.tenantId} />}
      </div>
    </PermissionGuard>
  );
};

export default AuditLogsDashboard;